import {MessageModel} from "../../pages/shared/models/message.model";
import {PayloadAction} from "@reduxjs/toolkit";

export function handleGetSectionMessages(state: MessagesState, payload: any): void {
    if (payload) {
        const parsedMessageData: {[key: string]: MessageModel} = {};
        payload.messages.forEach((message: MessageModel) => parsedMessageData[message.key] = message)

        state.messageCache[payload.sectionName] = parsedMessageData;
    }
}

export function handleLanguageChange(state: MessagesState, action: PayloadAction<number>): void {
    if (state.languageId !== action.payload) {
        state.messageCache = {};
    }
    state.languageId = action.payload;
}

export interface MessagesState {
    messageCache: {[key: string]: {[key: string]: MessageModel}},
    languageId: number
}

